<div *ngIf="hasData;else noData">
    <div [ngSwitch]="mediaType">
        <div *ngSwitchCase="videoType">
            <app-video [data]="data"></app-video>
        </div>
        <div *ngSwitchCase="imageType">
            <app-image [data]="data"></app-image>
        </div>
        <div *ngSwitchDefault>
            <div>指定された動画は存在しないか、すでに削除されています。</div>
        </div>
    </div>
    <div>
        <app-media-info [dateTime]="data?.dateTime"></app-media-info>
    </div>
    <div>
        <app-student-list [students]="data?.childInfos"></app-student-list>
    </div>
</div>

<ng-template #noData>データはありません。</ng-template>